import {Base} from "@/api/Base"

export class RoleLogsGetByIdEmp extends Base {
    path = "roleLogs/getByIdEmp"
}